import { render, staticRenderFns } from "./gOrderList.vue?vue&type=template&id=d2924282&scoped=true&"
import script from "./gOrderList.vue?vue&type=script&lang=js&"
export * from "./gOrderList.vue?vue&type=script&lang=js&"
import style0 from "./gOrderList.vue?vue&type=style&index=0&id=d2924282&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2924282",
  null
  
)

export default component.exports